export class sensitivityLabelChange {
    public isM365Connected: boolean = false;
    public resourceIdentifier : string = "";
    public newSensitivityLabel: string = "";
  }

